import { CaretIcon, UserIcon } from "components/page-components/Icons/small"
import React from "react"

export const HeaderDropdownButtonMobile = ({
  label,
  link,
  dropdown_menu_items,
  open_submenu,
  set_open_submenu,
}) => {
  const toggle_dropdown = (e) => {
    e.preventDefault()
    open_submenu === label ? set_open_submenu(false) : set_open_submenu(label)
  }
  return (
    <React.Fragment>
      <a
        style={{ height: 70, width: "100%" }}
        className="has-background-mitternachtsblau-10 has-text-mitternachtsblau is-flex px-5"
        onClick={toggle_dropdown}
        href=" #"
        onKeyPress={() => {}}
        tabIndex="-2"
        aria-label="toggle dropdown menu 2"
      >
        <div
          className="has-text-weight-bold has-background-mitternachtsblau-10 "
          style={{ margin: "auto", fontSize: 18 }}
        >
          <UserIcon {...{ size: 0.7 }} />
          <span className="ml-3">{label}</span>
        </div>
        <CaretIcon
          {...{
            size: 1,
            rotation: open_submenu === label ? "up" : "down",
          }}
        />
      </a>
      <div
        className={`mb-3 mobile-nav-dropdown`}
        style={{
          transition: "all .3s ease",
          maxHeight:
            open_submenu === label ? dropdown_menu_items.length * 70 : 0,
          visibility: open_submenu === label ? "visible" : "hidden",
          opacity: open_submenu === label ? 1 : 0,
        }}
      >
        {dropdown_menu_items.map(({ label, href }, index) => {
          return (
            <div
              key={`header_dropdown_button-${index}`}
              className="is-flex mobile-nav-dropdown-link"
            >
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="m-auto navbar-item"
              >
                <span className="header-link">{label}</span>
              </a>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}
